export const jobAlertConfig = {
  // Catchy alert text (can be updated from time to time)
  alertText: "🔥 Job Alert: Noida & Remote WFH roles open at Amazon, Teleperformance & TCS!",
  ctaText: "Get WhatsApp Alerts ➔",
  channelUrl: "https://whatsapp.com/channel/0029VbDcPbdJf05b1oC45s1i",
  showBar: true
};
